import MenuItem from 'components/MenuItem';
import Select from 'components/Select';

interface DistributionSelectProps {
  distributionOption: string;
  setDistributionOption: (value: string) => void;
}

const DistributionSelect = ({
  distributionOption,
  setDistributionOption
}: DistributionSelectProps) => {
  return (
    <div>
      <Select
        className="bg-white"
        labelId="grade-label"
        value={distributionOption}
        onChange={(e) => setDistributionOption(e.target.value)}
      >
        <MenuItem value="grade">Grade</MenuItem>
        <MenuItem value="gender">Gender</MenuItem>
        <MenuItem value="ethnicity">Ethnicity</MenuItem>
        <MenuItem value="state">State</MenuItem>
        <MenuItem value="english_learner_status">LEP</MenuItem>
        <MenuItem value="is_on_individualized_education_plan">IEP</MenuItem>
        <MenuItem value="is_low_income">Low Income</MenuItem>
      </Select>
    </div>
  );
};

export default DistributionSelect;
